var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    className: "question-mark_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.992a8 8 0 100 16 8 8 0 000-16zm-10 8c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10-10-4.477-10-10z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.133 10.492a1 1 0 11-1.73-1 3 3 0 015.597 1.5c0 1.097-.673 1.994-1.5 2.5-.664.406-.25 1.5-1.502 1.5a1 1 0 01-.995-1.104c.028-.529.264-.96.52-1.272.271-.33.628-.6.9-.762 1.517-.902-.333-2.747-1.29-1.361zm.865 5.5a1 1 0 100 2 1 1 0 000-2z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNSIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyIDQuOTkyYTggOCAwIDEwMCAxNiA4IDggMCAwMDAtMTZ6bS0xMCA4YzAtNS41MjMgNC40NzctMTAgMTAtMTBzMTAgNC40NzcgMTAgMTAtNC40NzcgMTAtMTAgMTAtMTAtNC40NzctMTAtMTB6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjEzMyAxMC40OTJhMSAxIDAgMTEtMS43My0xIDMgMyAwIDAxNS41OTcgMS41YzAgMS4wOTctLjY3MyAxLjk5NC0xLjUgMi41LS42NjQuNDA2LS4yNSAxLjUtMS41MDIgMS41YTEgMSAwIDAxLS45OTUtMS4xMDRjLjAyOC0uNTI5LjI2NC0uOTYuNTItMS4yNzIuMjcxLS4zMy42MjgtLjYuOS0uNzYyIDEuNTE3LS45MDItLjMzMy0yLjc0Ny0xLjI5LTEuMzYxem0uODY1IDUuNWExIDEgMCAxMDAgMiAxIDEgMCAwMDAtMnoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";
export { SvgQuestionMark as ReactComponent };